import { proxy } from '../url';
import axios from 'axios';

export const getProxy = async () => {
    return axios.get(proxy.get);
};

export const updateProxy = async (data) => {
    return axios.post(proxy.update, data);
};
